/* VoluFine · « Amato da migliaia » : barre de défilement qui suit (et se tire), « Leggi tutto / Mostra meno ».
   La page ne bouge jamais (scrollTo sur la piste, jamais scrollIntoView). */
(function(){
  function init(root){
    if(!root||root.dataset.ready)return; root.dataset.ready='1';
    var vp=root.querySelector('[data-vf07-vp]'), sb=root.querySelector('[data-vf07-sb]'), d=root.querySelector('[data-vf07-sbd]');
    var more=root.dataset.more||'', less=root.dataset.less||more;
    function upd(){ if(!vp||!sb)return; var max=vp.scrollWidth-vp.clientWidth, w=sb.clientWidth;
      var dw=Math.max(30,w*vp.clientWidth/Math.max(vp.scrollWidth,1)); d.style.width=dw+'px';
      d.style.transform='translateX('+(max>0?(w-dw)*vp.scrollLeft/max:0)+'px)'; sb.style.visibility=max>1?'visible':'hidden'; }
    if(vp){ vp.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); setTimeout(upd,100); }
    /* tirer la barre */
    var drag=null;
    function pos(e){ return (e.touches?e.touches[0].clientX:e.clientX); }
    function move(e){ if(!drag)return; var w=sb.clientWidth-d.offsetWidth, max=vp.scrollWidth-vp.clientWidth;
      vp.scrollLeft=drag.s+(pos(e)-drag.x)*(max/Math.max(w,1)); }
    if(sb){
      d.addEventListener('pointerdown',function(e){ drag={x:e.clientX,s:vp.scrollLeft}; vp.style.scrollSnapType='none'; e.preventDefault(); });
      window.addEventListener('pointermove',move);
      window.addEventListener('pointerup',function(){ if(drag){ drag=null; vp.style.removeProperty('scroll-snap-type'); } });
      sb.addEventListener('click',function(e){ if(e.target!==sb)return; var r=sb.getBoundingClientRect(); var max=vp.scrollWidth-vp.clientWidth;
        vp.scrollTo({left:max*(e.clientX-r.left)/r.width,behavior:'smooth'}); });
    }
    /* lire tout l'avis */
    [].slice.call(root.querySelectorAll('[data-vf07-more]')).forEach(function(b){
      var card=b.closest('.vf07-card'), txt=card.querySelector('.vf07-txt');
      function need(){ return txt.scrollHeight>txt.clientHeight+2; }
      setTimeout(function(){ if(!need()&&!card.classList.contains('is-open')) b.style.visibility='hidden'; },300);
      b.addEventListener('click',function(){ var o=card.classList.toggle('is-open'); b.textContent=o?less:more; upd(); });
    });
  }
  function all(){ [].slice.call(document.querySelectorAll('[data-vf07]')).forEach(init); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',all);
})();
